import React, { Suspense, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Container } from "reactstrap";

import profilePic from "assets/images/users/user-1.jpg";

const Topbar = React.lazy(() => import("./Topbar"));
const Sidebar = React.lazy(() => import("./Sidebar"));
const RightSidebar = React.lazy(() => import("./RightSidebar"));
const Footer = React.lazy(() => import("./Footer"));
const loading = () => <div className="text-center" />;

const RightSidebarContent = ({ user }) => (
  <div className="user-box">
    <div className="user-img">
      <img src={profilePic} alt="user-img" title="Nik Patel" className="rounded-circle img-fluid" />
      <a href="/" className="user-edit">
        <i className="mdi mdi-pencil"></i>
      </a>
    </div>

    <h5>{user && <a href="/">{user.username}</a>}</h5>
    <p className="text-muted mb-0">
      <small>Founder</small>
    </p>
  </div>
);

export default props => {
  const { children } = props;
  const history = useHistory();

  const { user } = useSelector(state => state.Auth.user);

  const [state, setState] = useState({
    isCondensed: false
  });

  const signOut = e => {
    e.preventDefault();
    history.push("/login");
  };

  /**
   * toggle Menu
   */
  const toggleMenu = e => {
    e.preventDefault();
    setState({ ...state, isCondensed: !state.isCondensed });
  };

  /**
   * Toggle right side bar
   */
  const toggleRightSidebar = () => {
    document.body.classList.toggle("right-bar-enabled");
  };

  return (
    <div className="app">
      <div id="wrapper">
        <Suspense fallback={loading()}>
          <Topbar
            sidebarIsCondensed={state.isCondensed}
            rightSidebarToggle={toggleRightSidebar}
            menuToggle={toggleMenu}
          />
          <Sidebar isCondensed={state.isCondensed} {...props} />
        </Suspense>
        <div className="content-page">
          <div className="content mb-5">
            <Container fluid>
              <Suspense fallback={loading()}>{children}</Suspense>
            </Container>
          </div>
        </div>

        <Footer />
      </div>

      <RightSidebar title={"Settings"}>
        <RightSidebarContent {...{ user }} />
      </RightSidebar>
    </div>
  );
};
